import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatRadioModule } from '@angular/material/radio';
import { MatToolbarModule } from '@angular/material/toolbar';

import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { RxListComponent } from './rx-list/rx-list.component';
import { RxListItemComponent } from './rx-list-item/rx-list-item.component';
import { RxListPhotoItemComponent } from './rx-list-photo-item/rx-list-photo-item.component';
import { RxRowModule } from '../rx-row/rx-row.module';
import { RxListRadioItemComponent } from './rx-list-radio-item/rx-list-radio-item.component';
import { RxListPhotoPairItemComponent } from './rx-list-photo-pair-item';
import { RxListGifItemComponent } from './rx-list-gif-item';
import { RxListVideoItemComponent } from './rx-list-video-item/rx-list-video-item.component';
import { RxListCaptureItemComponent } from './rx-list-capture-item/rx-list-capture-item.component';
import { RxListBundleItemComponent } from './rx-list-bundle-item/rx-list-bundle-item.component';
import { RxIconModule } from '../rx-icon/rx-icon.module';
import { RxRoleGuardModule } from 'libs/rx-directives/src/lib/rx-role-guard';

@NgModule({
  imports: [
    CommonModule,
    MatListModule,
    MatMenuModule,
    MatCheckboxModule,
    FormsModule,
    RxIconModule,
    RxRowModule,
    MatRadioModule,
    MatIconModule,
    RxRoleGuardModule,
    RxListComponent,
    RxListItemComponent,
    RxListPhotoItemComponent,
    RxListRadioItemComponent,
    RxListPhotoPairItemComponent,
    RxListGifItemComponent,
    RxListBundleItemComponent,
    RxListVideoItemComponent,
    RxListCaptureItemComponent,
  ],
  exports: [
    RxListComponent,
    RxListItemComponent,
    RxListPhotoItemComponent,
    RxListRadioItemComponent,
    RxListPhotoPairItemComponent,
    RxListGifItemComponent,
    RxListVideoItemComponent,
    RxListCaptureItemComponent,
    RxListBundleItemComponent,
  ],
})
export class RxListModule {}
